import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PAYGArrowIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <g transform="translate(-1.001 -2)">
                <path d="M27.249,10.75,15,2V7.25C-3.971,7.25,1.839,23,1.839,23S3.869,14.25,15,14.25V19.5Z" transform="translate(0)" fill={color} fillRule="evenodd"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 26.248 21'
}
